import {Component} from "@angular/core";
import {FUIFormContext} from "./form-context";
import {FUIPopFormContext} from "./pop-form-context";

@Component({
    selector: "fui-pop-form-context",
    template: "<ng-content></ng-content>",
    providers: [{provide: FUIFormContext, useClass: FUIPopFormContext}]
})
export class FUIPopFormContextComponent {
}
